import { useQuery } from "@tanstack/vue-query"

type MerchantDetailTerminal = {
  id: number
  serialNumber: string
  lastPaired: Date | null
  lastPairedVersion: string | null
  lastTransactedAt: Date | null
}

const parseMerchantDetailTerminal = (
  terminal: RecursivelyConvertDatesToStrings<MerchantDetailTerminal>
): MerchantDetailTerminal => ({
  ...terminal,
  lastPaired: terminal.lastPaired
    ? DateFns.parseISO(terminal.lastPaired)
    : null,
  lastTransactedAt: terminal.lastTransactedAt
    ? DateFns.parseISO(terminal.lastTransactedAt)
    : null,
})

type ListMerchantDetailTerminalsQuery = {
  merchantId: string
} & Pagination

const listMerchantDetailTerminals = async (
  query: ListMerchantDetailTerminalsQuery
) => {
  const { body } = await api.get<
    Paginate<
      RecursivelyConvertDatesToStrings<MerchantDetailTerminal>[]
    >
  >("/merchant-detail/terminals/", { query: query })

  return {
    ...body,
    items: body.items.map((terminal) =>
      parseMerchantDetailTerminal(terminal)
    ),
  }
}

export const useMerchantDetailTerminals = (
  query: MaybeRef<ListMerchantDetailTerminalsQuery>
) =>
  useQuery({
    queryKey: [
      TERMINALS_QUERY_KEY,
      MERCHANTS_QUERY_KEY,
      query,
    ] as const,
    queryFn: ({ queryKey: [_, __, query_] }) =>
      listMerchantDetailTerminals(unref(query_)),
  })
